import { useRouter } from 'next/router';
import * as R from 'ramda';
import parseURI from 'parse-uri';
// import { ParsedUrlQuery } from 'querystring';
import { snakeToCamel } from '@edx/helpers/string';
import { TrackCampaignInput } from '@edx/graphql/generated';

// type UseTrackCampaignsHookResult =
//   | {
//       referer: string | null;
//       utmParams: Pick<ParsedUrlQuery, Exclude<keyof ParsedUrlQuery, Exclude<keyof ParsedUrlQuery, string>>>;
//     }
//   | undefined;

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'automation_id'];

const utmParamsToCamelCase = R.compose(
  R.fromPairs,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  R.map(([utmParam, value]) => [snakeToCamel(utmParam), value]),
  R.toPairs
);

export const useTrackCampaigns = (key: string): TrackCampaignInput | undefined => {
  const router = useRouter();

  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const referer = document.referrer ? parseURI(document.referrer).host : null;
  const utmParams = R.pick(UTM_PARAMS, router.query);

  const isRefererMyself = location.host.includes(referer);

  // If no new request campaign or a valid referer, return the stored campaign.
  if (isRefererMyself || (!referer && Object.keys(utmParams).length < 1))
    return JSON.parse(window.localStorage.getItem(key) || '{}');

  const campaign = { referer, utmParams };
  window.localStorage.setItem(key, JSON.stringify(campaign));

  return campaign;
};

export const useTrackedCampaigns = (key: string): TrackCampaignInput | undefined => {
  if (typeof window === 'undefined') return;

  const { referer, utmParams } = JSON.parse(window.localStorage.getItem(key) || '{}');

  if (!referer && !utmParams) return undefined;

  const onlyAllowedParams = R.pick(UTM_PARAMS, utmParams);

  return {
    referer,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ...utmParamsToCamelCase(onlyAllowedParams),
  };
};
